import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App.js";
import { I18nProvider } from "./i18n/I18nProvider.js";
import { LearnContentBundleProvider } from "./learn/offlineBundle.js";
import { ContentStatusProvider } from "./offline/ContentStatusProvider.js";
import { registerOfflineServiceWorker } from "./offline/serviceWorkerBridge.js";
import "./styles/global.css";

const rootElement = document.querySelector<HTMLDivElement>("#root");

if (rootElement === null) {
  throw new Error("SafeSphere root element was not found.");
}

createRoot(rootElement).render(
  <StrictMode>
    <I18nProvider>
      <ContentStatusProvider>
        <LearnContentBundleProvider>
          <App />
        </LearnContentBundleProvider>
      </ContentStatusProvider>
    </I18nProvider>
  </StrictMode>,
);

registerOfflineServiceWorker();
